/**
 * Analytics configuration
 *
 * Project tokens are not secret - they're embedded in client bundles.
 * Mixpanel expects this and has server-side filtering for abuse.
 */

// Determine environment from Vite
const stage = import.meta.env.VITE_STAGE || (import.meta.env.PROD ? 'prod' : 'dev');

const MIXPANEL_TOKENS = {
  dev: 'd963ff88901466e286bcb3bc0c21b465',
  prod: 'f162d9ac854048a2c960534931437b84',
} as const;

// VITE_STAGE is "local" (dev server), "dev" (dev deploy), "blue"/"green" (prod deploy)
const PROD_STAGES = new Set(['blue', 'green', 'prod']);
export const MIXPANEL_TOKEN = PROD_STAGES.has(stage) ? MIXPANEL_TOKENS.prod : MIXPANEL_TOKENS.dev;

export const ANALYTICS_CONFIG = {
  /** Enable debug logging in development */
  debug: import.meta.env.DEV,
  /** Track page views automatically */
  trackPageViews: false, // We track manually for more control
  /** Persistence type */
  persistence: 'localStorage' as const,
};
